import React from "react";
import { 
  Button,
  Box, 
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography, 
} from "@material-ui/core"
import Util from "../../common/Util"
import Provinces from "../../common/Provinces"
class CardDDJJ extends React.PureComponent{
  constructor(props){
    super(props)
  }

  renderItem(label, value){
    let isBoolean = typeof value == 'boolean'
    return (
      <Box style={{margin:4}}>
        <Typography style={{fontWeight:"bold"}}>{label}</Typography>
        <Typography style={{color:"rgb(0,0,0,0.8)"}}>{isBoolean?(value?"SI":"NO"):value}</Typography>
      </Box>
    )
  }

  render(){
    const { item, textInCircle } = this.props
    if(!item){
      return null;
    }
    const ddjjDate = Util.timestampToMoment(item.ddjjDate)
    let address = ""
    if(item.adrStreetComplete){
      address+=item.adrStreetComplete
    }
    if(item.adrCity){
      address+=", " + item.adrCity
    }
    if(item.adrState>=0&&item.adrState<=22){
      address+=", " + Provinces[item.adrState]
    }
    return (
      <Card variant="outlined" style={{backgroundColor:"#f5f5f5"}}>
        <CardContent>
          <Grid container>
            <Grid item direction="row" xs={10}>
              <Box style={{display:"flex"}}>
                <Typography style={{fontWeight:"bold"}}>Fecha:</Typography>
                <Typography style={{marginLeft:4, color:"rgb(0,0,0,0.8)"}}>{ddjjDate.format("DD/MM/YYYY - HH:mm")}</Typography>
              </Box>
            </Grid>
            <Grid item style={{backgroundColor:"#000", paddingLeft:10, paddingRight:10, borderRadius:100, paddingTop:4, paddingBottom:4}}>
              <Typography style={{fontSize:14, color:"white"}}>{textInCircle||`Mesa ${item.commerceTable}`}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              {this.renderItem("Nombre y Apellido", `${item.name} ${item.lastname}`)}
            </Grid>
            <Grid item xs={6}>
              {this.renderItem("DNI", Util.formatNumber(item.docNumber))}  
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              {this.renderItem("E-mail", item.email)}
            </Grid>
            <Grid item  xs={6}>
              {this.renderItem("Teléfono", item.phoneNumber)}
            </Grid>
          </Grid>
          <Grid container>
            {this.renderItem("Domicilio", address)}
          </Grid>
          <Grid container>
            {this.renderItem("¿Ha estado expuesto a grupos humanos numerosos, desconocidos, sin respetarla distancia social establecida?", item.optCrowded)}
          </Grid>  
          <Grid container>
            {this.renderItem("¿Permaneció en lugares cerrados con grupos humanos numerosos por más de 30 minutos seguidos, respetando o no la distancia social?", item.optClosedPlaces)}
          </Grid>
          <Grid container>
            {this.renderItem("¿En el día de la fecha, Ud. ha utilizado transporte público de pasajeros?", item.optPublicTransport)}
          </Grid>
          <Grid container>
            {this.renderItem("Ha desarrollado en los últimos 5 días episodios febriles con temperatura mayor a los 37, 5°", item.optFever5)}
          </Grid>
          <Grid container>
            {this.renderItem("¿En los últimos 14 días, ha estado en contacto con personas sospechosas o confirmadas de COVID–19?", item.optContact14)}
          </Grid>
          <Grid container>
            {this.renderItem(" ¿En los últimos 14 días, ha permanecido o visitado alguno de los hospitales COVID–19 en el ámbito de la República Argentina?", item.optHospital14)}
          </Grid>
          <Grid container>
            {this.renderItem("¿Ha regresado de viaje en los últimos 14 días?", item.optTravel14)}
          </Grid>
          <Grid container>
            {item.optTravel14&&this.renderItem("¿Desde qué país ha regresado?", item.optTravel14Country)}
          </Grid>
        </CardContent>
      </Card>
    )
  }
}

export default CardDDJJ


// WEBPACK FOOTER //
// ./src/components/CardDDJJ/CardDDJJ.js